const AUTH_TOKEN = $('meta[name="csrf-token"]').attr('content');

import moment from 'moment';

window.CreateDealInformationRequest = {
    init() {
        this.initDropZone();
        this.setDatePicker();
    },

    setDatePicker() {
        let currentDate = new Date();
        let dateInput = $(document.getElementById('deal_information_request[deadline]'));

        let numToAdd = 2;

        for (let i = 1; i <= numToAdd; i++) {
            currentDate.setDate(currentDate.getDate() + 1);
            if (currentDate.getDay() === 6) {
                currentDate.setDate(currentDate.getDate() + 2);
            } else if (currentDate.getDay() === 0) {
                currentDate.setDate(currentDate.getDate() + 1);
            }
        }

        let deadlineDate = moment(currentDate).format('YYYY-MM-DD');

        dateInput.val(deadlineDate);
        dateInput.attr("min", deadlineDate);
    },

    initDropZone() {
        const submitButton = document.getElementById('rfi-continue-modal-btn');
        const self = this

        const showPreviewLoader = (file) => {
            if (!file?.previewElement) return;
            $(file.previewElement).find('.dz-uploading-loader').removeClass('d-none');
            $(file.previewElement).find('.dz-remove').addClass('d-none'); // avoid removing mid-upload
        };

        const hidePreviewLoader = (file) => {
            if (!file?.previewElement) return;
            $(file.previewElement).find('.dz-uploading-loader').addClass('d-none');
            $(file.previewElement).find('.dz-remove').removeClass('d-none');
        };

        $(".add-info-request-btn").not(".dz-clickable").each((index, element) => {
            $(element).dropzone({
                url: "/deal_information_requests/upload_deal_information_request_attachment",
                previewsContainer: document.querySelector('.drop-zone-preview.info-request'),
                previewTemplate: document.querySelector('.drop-zone-custom.info-request').innerHTML,
                uploadMultiple: false,
                maxFiles: 10,
                maxFileSize: 10,
                acceptedFiles: ".jpg,.jpeg,.gif,.png,.tiff,.bmp,.webp,.txt,.csv,.pdf,.xls,.xlsx,.xlsm,.doc,.docx,.zip",
                init: function () {
                    this.on("error", function (file) {
                        hidePreviewLoader(file);
                        this.removeFile(file);
                        $('#deal-information-request-attachments').after(
                            '<div class="alert alert-danger alert-dismissable" id="rr-success-alert">' +
                            '<button type="button" class="close" ' +
                            'data-dismiss="alert" aria-hidden="true">' +
                            '&times;' +
                            '</button>' +
                            'An error has occurred uploading file' +
                            '</div>'
                        );
                        submitButton.disabled = false;
                    });

                    this.on("complete", function (file) {
                        hidePreviewLoader(file);
                    });
                },
                params: {
                    'authenticity_token': AUTH_TOKEN
                },
                timeout: 60000,
                success: (file, response) => {
                    if (response.err_msg == '' || response.err_msg == undefined) {
                        const dealInformationRequestAttachmentsElement = $("#deal-information-request-attachments");
                        $(file.previewElement).find('.remove-attachment').attr('data-attachment-id', response.id);
                        dealInformationRequestAttachmentsElement.append(`<input type='hidden' value='${response.id}' name='deal_information_request[deal_information_request_attachment_ids][]'>`);
                        self.handleOnClickRemoveAttachment();
                    } else {
                        alert(response.err_msg);
                        file.previewElement.remove();
                    }
                    submitButton.disabled = false;
                },
                sending: (file) => {
                    showPreviewLoader(file);
                    submitButton.disabled = true;
                }
            });
        });

        $("#rr-success-alert").fadeTo(5000, 500).slideUp(500, function () {
            $("#rr-success-alert").slideUp(500);
        });
        setTimeout(function () {
            $("#rr-success-alert").remove();
        }, 6000);
    },

    handleRemoveAttachment(e) {
        const attachmentId = e.target.dataset.attachmentId;
        $(`#deal-information-request-attachments :input[value="${attachmentId}"]`).remove();
        $(e.target).parents('.drop-zone-preview.info-request').remove();
    },

    handleOnClickRemoveAttachment() {
        $(".remove-attachment").on('click', this.handleRemoveAttachment.bind(this));
    },
};
